import StarterKit from "./StarterKit";

import Header from "./components/Header";
import NavsFull from "./components/NavsFull";
import NavsBurger from "./components/NavsBurger";

import BlockBanner from "./blocks/BlockBanner";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockGallery from "./blocks/BlockGallery";
import BlockGallerySlider from "./blocks/BlockGallerySlider";
import BlockGallerySliderSimple from "./blocks/BlockGallerySliderSimple";
import BlockMap from "./blocks/BlockMap";
import BlockMovie from "./blocks/BlockMovie";
import BlockQuotes from "./blocks/BlockQuotes";
import BlockSlider from "./blocks/BlockSlider";
import BlockSliderScrollable from "./blocks/BlockSliderScrollable";
import BlockScrollingText from "./blocks/BlockScrollingText";

import Share from "./components/Share";
import BlockAnchor from "./blocks/BlockAnchor";
import Booking from "./components/Booking";
import BlockTextSlider from "./blocks/BlockTextSlider";
import Follower from "./components/Follower";
import BlockSpecialOffer from "./blocks/BlockSpecialOffer";
import BlockTestimony from "./blocks/BlockTestimony";
import BlockScrollingTextImage from "./blocks/BlockScrollingTextImage";
import BlockActivities from "./blocks/BlockActivities";
import BlockSliderTab from "./blocks/BlockSliderTab";
import BlockNews from "./blocks/BlockNews";
import Banner from "./components/Banner";
import BlockRooms from "./blocks/BlockRooms";
import BlockRestoBar from "./blocks/BlockRestoBar";
import BlockDestination from "./blocks/BlockDestination";
import BlockTextLetter from "./blocks/BlockTextLetter";

window.initMap = function(){
	window.dispatchEvent(new Event('googleMapApiLoaded'));
};

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Components
	Banner.init();
	Header.init();
	NavsFull.init();
	NavsBurger.init();

	// Blocks
	BlockActivities.init();
	BlockAnchor.init();
	BlockBanner.init();
	BlockCollapse.init();
	BlockDestination.init();
	BlockGallery.init();
	BlockGallerySlider.init();
	BlockGallerySliderSimple.init();
	BlockMap.init();
	BlockMovie.init();
	BlockNews.init();
	BlockQuotes.init();
	BlockRooms.init();
	BlockRestoBar.init();
	BlockScrollingText.init();
	BlockScrollingTextImage.init();
	BlockSlider.init();
	BlockSliderTab.init();
	BlockSliderScrollable.init();
	BlockSpecialOffer.init();
	BlockTextLetter.init();
	BlockTextSlider.init();
	BlockTestimony.init();

	Booking.init();

	Follower.init();
	Share.init();

	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
	const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
});
